import SwitcherButton from "../../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import { EnumRootEventBus, rootEventBus } from "../../../../../../../src/managers/RootEventBus";
import { TestSwitcherButtonStyles } from "../../../types/Config";
import { DrawingTool, QuestionMode, QuestionType } from "../../../types/Enum";
import { EnumEventBus, eventBus } from "../../EventBus";
import addButton from "../helpers/addButtonHelper";
import setQuestionTypes from "./helpers/setQuestionTypes";

const emptyFunc = () => { }

export default class TestButtonFactory {

  static genGoToTestModeButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.setQuestMode, QuestionMode.practise)
      setTimeout(() => button.closeButton(), 200);
    }
    const onHandleSecondFunc = () => { };
    const sButtonStyle = TestSwitcherButtonStyles.gotoPractiseMode;
    button = addButton("Go To Practise Mode", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
    return button;
  }
  static genGenNextQuestionButton(): SwitcherButton {
    let button: SwitcherButton;
    eventBus.on(EnumEventBus.startAnswer, (v) => v && button.setDisabled(true));
    eventBus.on(EnumEventBus.saveAnswer, () => button.setDisabled(false));

    const onHandleFunc = () => {
      rootEventBus.emit(EnumRootEventBus.cancelledCircleAnim);
      eventBus.emit(EnumEventBus.setSelectedTool, DrawingTool.empty);
      eventBus.emit(EnumEventBus.newQuestion);
      eventBus.emit(EnumEventBus.startAnswer, false);
      eventBus.emit(EnumEventBus.clearAll);
      setTimeout(() => button.closeButton(), 200);
    }
    const sButtonStyle = TestSwitcherButtonStyles.nextQuestion;
    return button = addButton("Generate Next Question", onHandleFunc, emptyFunc, sButtonStyle, undefined, false);
  }
  static genShowResults(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.showResults);
      setTimeout(() => button.closeButton(), 200);
    };
    const sButtonStyle = TestSwitcherButtonStyles.nextQuestion;
    return button = addButton("Show Results", onHandleFunc, emptyFunc, sButtonStyle, undefined, false);
  }
  static genStartAnswerButton(): SwitcherButton {
    let DAT: DrawingTool = DrawingTool.answerLine;
    let button: SwitcherButton;
    const setAnswerMode = (v: boolean) => {
      eventBus.emit(EnumEventBus.startAnswer, v)
      if (v) {
        return eventBus.emit(EnumEventBus.setSelectedTool, DAT);
      }
      button.closeButton();
      eventBus.emit(EnumEventBus.setSelectedTool, DrawingTool.empty);
    }

    eventBus.on(EnumEventBus.questionType, (type: QuestionType) => {
      DAT = type == QuestionType.TYPE1 ? DrawingTool.answerLine : DrawingTool.answerPoint;
      button.closeButton();
    });
    eventBus.on(EnumEventBus.saveAnswer, () => setAnswerMode(false));
    const onHandleFunc = () => setAnswerMode(true);
    const onHandleSecondFunc = () => setAnswerMode(false);
    const sButtonStyle = TestSwitcherButtonStyles.giveAnswer;
    return button = addButton("Start Answer", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
  }
  static genSaveAnswerButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.saveAnswer);
      setTimeout(() => button.closeButton(), 200);
    }
    const sButtonStyle = TestSwitcherButtonStyles.saveAnswer;
    return button = addButton("Save Answer", onHandleFunc, emptyFunc, sButtonStyle, undefined, false);
  }
  static genGoToPractiseButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.setQuestMode, QuestionMode.practise)
      setTimeout(() => button.closeButton(), 200);
    }
    const sButtonStyle = TestSwitcherButtonStyles.goToPractise;
    return button = addButton("Go To Practise", onHandleFunc, emptyFunc, sButtonStyle, undefined, false);
  }
  static genTryAgainButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.setQuestMode, QuestionMode.test)
      setTimeout(() => button.closeButton(), 200);
    }
    const sButtonStyle = TestSwitcherButtonStyles.tryAgain;
    return button = addButton("Try Again", onHandleFunc, emptyFunc, sButtonStyle, undefined, false);
  }
}